const types = [
  'Audio',
  'Ball-Triangle',
  'Bars',
  'Circles',
  'Grid',
  'Hearts',
  'Oval',
  'Puff',
  'Rings',
  'TailSpin',
  'ThreeDots',
];

export default function () {
  return types[Math.ceil(Math.random() * (types.length - 1))];
}
